import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({ showModal, title, message, onConfirm, onClose, mode }) => (
    <Modal show={showModal}>
        <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>{message}</p>
            {mode === 'closeAbnormality' && (
                <p>
                    <b>
                        An abnormality cannot be reopened when confirmed as closed. A new
                        abnormality will have to be created instead.
                    </b>
                </p>
            )}
        </Modal.Body>
        <Modal.Footer>
            <div className="pull-right">
                <Button
                    style={{ marginRight: 20 }}
                    bsStyle="primary"
                    onClick={() => onConfirm(mode)}
                >
                    Yes
                </Button>
                <Button style={{ marginRight: 20 }} bsStyle="default" onClick={onClose}>
                    No
                </Button>
            </div>
        </Modal.Footer>
    </Modal>
);

export default ConfirmationModal;
